<template>
  <DSTooltip>
    <DSTooltipTrigger as-child>
      <DSButton
        variant="secondary"
        size="icon-sm"
        :aria-label="open ? 'Hide fields' : 'Show fields'"
        @click="open = !open"
      >
        <Settings2Icon
          v-if="isMobile"
          class="size-3.5"
        />
        <template v-else>
          <ChevronsLeft
            v-if="open"
            class="size-3.5"
          />
          <ChevronsRight
            v-else
            class="size-3.5"
          />
        </template>
      </DSButton>
    </DSTooltipTrigger>
    <DSTooltipContent>{{ open ? 'Hide fields' : 'Show fields' }}</DSTooltipContent>
  </DSTooltip>
</template>

<script setup lang="ts">
import { ChevronsLeft, ChevronsRight, Settings2Icon } from '@lucide/vue'

import { DSButton, DSTooltip, DSTooltipContent, DSTooltipTrigger } from '@ds'

type Props = {
  isMobile?: boolean
}

const { isMobile = false } = defineProps<Props>()

const open = defineModel<boolean>('open', { required: true })
</script>
